import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const AuthLayout = ({ isSignedIn }) => {

    const location = useLocation()

    console.log('authcheck', isSignedIn)

    if (!isSignedIn && location.pathname == '/') {
        return <Navigate to='/signin' />
    }

    if (isSignedIn) return <Navigate to='/dashboard' />

    return <Outlet />

}

export default AuthLayout